<template>
    <div id="jurisdictionInfo">
        <jurisdicBar v-if="onoffNavBar" :tags="tags"
                     :title="title"
                     :date="data"
                     :subTitle1="subTitle1"
                     :subTitle2="subTitle2"
                     :address="address"
                     :target_num="target_num"
                     :cover_num="cover_num"
                     :institution_grade="institution_grade"
                     :btnBack="true"
                      @btnBackClick="handleBackClick"/>
        <el-row style="margin-top: 10px">
            <el-col :span="24">
            <el-row>
                <el-col :span="24" style="height: 300px">
                    <el-amap vid="amap"
                             :zoom="zoom"
                             :center="center"
                             :plugin="plugin">
                        <el-amap-marker
                                :position="center" >
                        </el-amap-marker>
                    </el-amap>
                </el-col>
            </el-row>
            </el-col>
            <el-col :span="24">
            <el-row style="margin-top: 30px">
                <el-col :span="24" style="min-height: 152px">
                    <span style="font-weight: bold;float: left;width: 100px;margin-top: 20px">签入照片</span>
                    <ul style="float: left;width: calc(100% - 100px)">
                        <li
                                style="display: inline-block;margin-left: 30px;width: 130px;height: 130px;cursor: pointer;
                                margin-top:20px;overflow: hidden;position: relative;border-radius: 10px;"
                            @click="dialogVisibles(item)"
                            v-for="(item,j) in photoArrayIn"  >
                            <img :src="item"    style="display: block;object-fit: cover;
                            width:130px;
                            height:130px;
                            position:absolute;top: 50%;left: 50%;transform: translate3d(-50%,-50%,0);"/>
                        </li>

                    </ul>
                </el-col>
                <el-col :span="24" style="min-height: 152px;">
                    <span style="font-weight: bold;float: left;width: 100px;margin-top: 20px">签出照片</span>
                    <ul style="float: left;width: calc(100% - 100px)">
                        <li style="display: inline-block;margin-left: 30px;cursor: pointer;
                        width: 130px;height: 130px;margin-top: 20px;overflow: hidden;
                        position: relative;border-radius: 10px;"
                            v-for="(item,j) in  photoArrayOut"  @click="dialogVisibles(item)">
                            <img :src="item"    style="display: block;object-fit: cover;
                            width:130px;
                            height:130px;
                            position:absolute;top: 50%;left: 50%;transform: translate3d(-50%,-50%,0);"/>
                        </li>

                    </ul>
                </el-col>
                <el-col :span="24" style="min-height: 152px;margin-top: 20px">
                    <span style="font-weight: bold;float: left;width: 100px;margin-top: 20px">备注</span>
                    <p style="float: left;width: calc(100% - 130px);margin-left: 30px;margin-top: 20px"
                       v-text="formInfo.comments"></p>
                </el-col>

            </el-row>

            </el-col>
        </el-row>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogSrc" alt="">
        </el-dialog>
    </div>

</template>

<script>
    import jurisdicBar from './components/jurisdicBar'
    import http from '../../../APIService/http'
    import moment from 'moment'
    export default {
        name: "jurisdictionInfo",
        data (){
            return {
                tags: ['辖区事务','辖区签到'],
                title:'',
                data:{},
                zoom: 16,
                center: [116.46, 39.92],
                onoffNavBar:false,
                photoArrayIn:[],
                photoArrayOut:[],
                formInfo:{
                    checkin_id: "",
                    checkin_time: "",
                    checkin_lat: 31.263504,
                    checkin_lng: 121.419573,
                    checkout_time: "",
                    checkout_lat: 31.263501,
                    checkout_lng: 121.419571,
                    location_name: "",
                    address: "",
                    comments: "",
                    retroactive: null,
                    lng: 121.431321,
                    lat: 31.266771,
                    location_id: "",
                    checkin_date: "",
                    created_by: "",
                    reference_id: "",
                    photo_id: [],
                    category: [],
                    isCheckinOutStore: "",
                    isCheckinOutTime: "",
                },
                dialogVisible:false,
                dialogSrc:'',
                plugin: [{
                    pName: 'ToolBar',
                    position:'RT',
                    locate:false,
                    events: {
                        init(instance) {
                        }
                    }
                }],
            }
        },
        components:{
            jurisdicBar,
        },
        created(){

        },
        updated(){
        },
        mounted(){
            if(Object.keys(this.$route.params).length === 0){
                let condition = localStorage.getItem('condition')
                this.data = JSON.parse(condition)
                this.init()
            }else {
                this.data = this.$route.params
                this.init()

            }

        },
        methods:{
            dialogVisibles(photoUrl) {

                this.dialogSrc = photoUrl
                this.dialogVisible = true
            },
           async init(){
               let loading = this.$loading({
                   lock: true,
                   text: '拼命加载中',
                   spinner: 'el-icon-loading',
                   background: 'rgba(0, 0, 0, 0.7)'
               });
                try {
                    let user = this.$store.getters.getUser
                    let obj = {
                        tenant_id : this.data.tenant_id,
                        user_id : this.data.created_by,
                        location_type : this.data.location_type,
                        checkin_id : this.data.checkin_id,
                    }
                    let data ={
                        tenant_id:user.tenant_id,
                        service_id : "crm_server",
                        client_secret: "0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4",
                        client_id : "com.saasyun.android",
                        username:user.username,
                        token : "742fcc1c-9221-afa0-d043-c7b1724250c8",
                        data : JSON.stringify(obj)
                    }
                    await http.post('/wapi/JurisdictionIn/getCheckInfo',data).then(res=>{
                        if (res.success === true){
                            this.formInfo = res.data[0]

                            this.center = [this.formInfo.lng,this.formInfo.lat]
                            let obj = res.data[0]
                            this.getCheckListById(obj)
                           let item =[]
                            for (let i=0;i<this.formInfo.category.length;i++){
                                let imgInfo = {
                                     id : this.formInfo.photo_id[i],
                                     type : this.formInfo.category[i]
                                }
                               item.push(imgInfo)
                            }
                          for (let j=0;j<item.length;j++){

                              if (item[j].id !== null){
                                  this.getImgUrl(item[j])
                              }else {
                                  continue
                              }
                          }
                            loading.close()
                        }
                    })
                }catch (e) {
                    loading.close()
                }
            },


            handleBackClick(){
                this.$router.go(-1)
            },
           async getCheckListById(){
               try {
                   let user = this.$store.getters.getUser
                   let data= {
                       tenant_id : user.tenant_id,
                       user_id : user.user_id,
                       date : this.formInfo.checkin_date,
                       id : this.formInfo.reference_id
                   }
                   await http.post('/wapi/Conference/getCheckListById',data).then(res=>{

                        if (res.success === true){
                            this.data.array = res.data
                            this.onoffNavBar = true
                            // console.log(res)
                        }
                            this.onoffNavBar = true

                   })
               }catch (e) {

               }
            },
            // 获取图片id
            async getImgUrl(obj) {
                try {
                    let data = {
                        reference_obj: 'INSTITUTION',
                        reference_id: 'com.saasyun.android',
                        credential: '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4',
                        photo_ids: obj.id,
                        tenant_id: this.$store.getters.getUser.tenant_id
                    }

                    let res = await http.post('/photos/downloadphotos', data)
                    let array = res.data


                    if (array.length > 0) {
                        // this.photoItem.photoUrl = array[0].thu_url
                        if (obj.type === 'CHECK_IN') {
                            this.photoArrayIn.push(array[0].thu_url)
                        }else {
                            this.photoArrayOut.push(array[0].thu_url)

                        }
                        // loading.close()
                        this.$forceUpdate()

                    }

                } catch (err) {
                    console.log(`error:${err}`)
                }
            },
        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/calendar/components/jurisdictionInfo.vue